/**

 * @param {Record<string, any>} queryParams - An object containing the query parameters as key-value pairs.
 * 
 * @returns {string} - The constructed query string, starting with '?' if there are any parameters.
 */
export const buildQueryString = (queryParams?: Record<string, any>): string => {
    if (!queryParams) return '';
  
    const queryParts: string[] = [];
  
    for (const [key, value] of Object.entries(queryParams)) {
      if (value !== undefined && value !== null) {
        queryParts.push(`${key}=${encodeURIComponent(value)}`);
      }
    }
    return queryParts.length > 0 ? `?${queryParts.join('&')}` : '';
  };
  